import * as React from 'react'

import { Organization } from '../../../models'
import styles from './OrganizationEntry.scss'

export interface Props {
  organization: Organization
  children: JSX.Element[]
  isSearching: boolean
  qty: number
  idx: number
}

const OrganizationEntry = ({ organization, children, qty, idx, isSearching }: Props) => (
  <div data-cy={`organizationEntry_${organization.id}`} className={styles.organization_container}>
    {!isSearching ?
      <>
        <div
          data-cy="organizationName"
          className={styles.organization_name}
        >
          {organization.name}
        </div>
        <div
          data-cy="organizationUserType"
          className={styles.user_type}
        >
          {organization.actions.length > 1 ? 'Organization Owner' : 'Organization Member'}
        </div>
        {children}
        {qty > 1 && (qty - 1) !== idx ? <div className={styles.divisor} /> : null}
      </> : <>{children}</>
    }
  </div>
)

export default OrganizationEntry
